import React from 'react';
import './UaeLoading.css';

export default function UaeLoading({ scheme = 'visa' }) {
  const isMc = scheme === 'mastercard' || scheme === 'mc';

  return (
    <div className="uae-loading-wrapper">
      <div className="uae-loading-container">
        <div className="uae-ios-spinner" aria-label="Loading">
          <div className="uae-bar" />
          <div className="uae-bar" />
          <div className="uae-bar" />
          <div className="uae-bar" />
          <div className="uae-bar" />
          <div className="uae-bar" />
          <div className="uae-bar" />
          <div className="uae-bar" />
          <div className="uae-bar" />
          <div className="uae-bar" />
          <div className="uae-bar" />
          <div className="uae-bar" />
        </div>

        {isMc ? (
          <div className="uae-logo-mc">
            <img src="/images/banks/uae/mc_id_check.png" alt="Mastercard Identity Check" />
          </div>
        ) : (
          <div className="uae-logo-secure">
            <img src="/images/banks/uae/visa_secure.svg" alt="Visa Secure" />
          </div>
        )}
      </div>
    </div>
  );
}
